import ComponentRegister from '../utils/ComponentRegister';

import ShareLink from '../bundles/ShareLink';

ComponentRegister.setup({
  ShareLink,
});
